export default __webpack_public_path__ + "resources/icons/d422-7cf9.png";